import { createStore, applyMiddleware, compose } from 'redux';
import logger from "redux-logger";
import rootReducer from "./reducers";
import { jwtDecode } from "jwt-decode";
import { logoutuser } from "../helper/constant";

let middleware = [];

// if (process.env.NODE_ENV !== `production`) {
//   middleware.push(logger);
// }

//middleware verify token
const verifyToken = ( store ) => {
  return ( next ) => {
      return async( action ) => {
        let user = localStorage.getItem("user");
        let admin = localStorage.getItem("admin");
        let supplier = localStorage.getItem("supplier");
        let parsedUser = JSON.parse(user);
        let parsedAdmin = JSON.parse(admin);
        let parsedSupplier = JSON.parse(supplier);
        let parsedToken = localStorage.getItem("token");

        if(parsedUser || parsedAdmin || parsedSupplier){
          const token = parsedToken?.split(' ')[1];
          const decodedToken = jwtDecode(token);

          if (decodedToken.user_id.includes("user")) {
            decodedToken.userId = decodedToken.user_id.split("u")[0];
          }else{
            decodedToken.userId = decodedToken.user_id.split("m")[0];
          }

          if(parsedUser){
            if(parsedUser?.cust_id === parseInt(decodedToken.userId)){
              return next( action );
            }
            logoutuser();
          }else if(parsedAdmin){
            if(parsedAdmin?.id === parseInt(decodedToken.userId)){
              return next( action );
            }
            logoutuser();
          }else if(parsedSupplier){
            if(parsedSupplier?.id === parseInt(decodedToken.userId)){
              return next( action );
            }
            logoutuser();
          }
        }
        return next ( action );
      };
  };
};

middleware = [...middleware, verifyToken]

const ConfigureStore = () => {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return createStore(rootReducer, composeEnhancers(applyMiddleware(...middleware)));
};

// const ConfigureStore = () => {
//   return createStore(rootReducer, applyMiddleware(...middleware),window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
// };
export default ConfigureStore;
